import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "AuthorArchive",
    component: () => (__SERVER__ ? require("./author-archive-view") : import("./author-archive-view"))
});

export default definition;
